﻿export class TruckLoadDTO {
    loadingId: number;
    diggingPatternId: number;
    destinationId: number;
    truckId: number;
    loads: number;
    hour: number;
    tonnes?: number;
    materialTypeClassId: number;
    addedBy?: string;
    updatedBy?: string;
    rowVersion?: string;

    constructor(data: {
        loadingId: number;
        diggingPatternId: number;
        destinationId: number;
        truckId: number;
        loads: number;
        hour: number;
        tonnes?: number;
        materialTypeClassId: number;
        addedBy?: string;
        updatedBy?: string;
        rowVersion?: string;
    }) {
        this.loadingId = data.loadingId;
        this.diggingPatternId = data.diggingPatternId;
        this.destinationId = data.destinationId;
        this.truckId = data.truckId;
        this.loads = data.loads;
        this.hour = data.hour;
        this.tonnes = data.tonnes;
        this.materialTypeClassId = data.materialTypeClassId;
        this.addedBy = data.addedBy;
        this.updatedBy = data.updatedBy;
        this.rowVersion = data.rowVersion;
    }
}